module.exports = "https://cdn-challenge.mathletics.com/app/107/assets/images/a02b2b5bec6993ad20ec9becbc49b822.svg";